export class ValidationError extends Error {
  name = "ValidationError";
}
